




























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditKebersihanRuangService from "@/services/AuditKebersihanRuangService";
import { KRITERIA_AUDIT_KEBERSIHAN_RUANG, KRR_ITEM_COUNT } from "@/constants/kriteriaAuditKebersihanRuang";

type Penilaian = "ya" | "tidak" | "na" | null;

interface ResponseRow {
  id?: number;
  kriteria_no: number;
  penilaian: Penilaian;
  catatan: string;
}

@Component
export default class AuditKebersihanRuangKriteriaLogger extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  sessionNomor = "";
  kriteriaList = KRITERIA_AUDIT_KEBERSIHAN_RUANG;
  itemCount = KRR_ITEM_COUNT;

  responseMap: Record<number, ResponseRow> = {} as any;

  saving = false;
  submitting = false;
  submitDialog = false;
  submitForm: any = { password: "" };
  dirty = false;

  async mounted() {
    await this.loadSession();
    this.initResponses();
  }

  async loadSession() {
    const res = await AuditKebersihanRuangService.find(this.sessionId);
    this.session = res.data.data;
    this.sessionNomor = this.session.nomor_formulir;
  }

  initResponses() {
    const existing: Record<number, any> = {};
    (this.session.responses || []).forEach((r: any) => {
      existing[r.kriteria_no] = r;
    });
    for (let k = 1; k <= this.itemCount; k++) {
      const e = existing[k];
      this.$set(this.responseMap, k, {
        id: e?.id,
        kriteria_no: k,
        penilaian: (e?.penilaian as Penilaian) ?? null,
        catatan: e?.catatan || ""
      });
    }
  }

  setPenilaian(k: number, v: "ya" | "tidak") {
    // Toggle: if already this value, clear to null
    if (this.responseMap[k].penilaian === v) {
      this.responseMap[k].penilaian = null;
    } else {
      this.responseMap[k].penilaian = v;
    }
    this.markDirty();
  }

  clearAllPenilaian() {
    for (let k = 1; k <= this.itemCount; k++) {
      this.responseMap[k].penilaian = null;
    }
    this.markDirty();
  }

  markDirty() {
    this.dirty = true;
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  get filledCount(): number {
    return Object.values(this.responseMap).filter(r => r.penilaian).length;
  }

  get totalPatuh(): number {
    return Object.values(this.responseMap).filter(r => r.penilaian === "ya").length;
  }

  get totalTidak(): number {
    return Object.values(this.responseMap).filter(r => r.penilaian === "tidak").length;
  }

  get overallRate(): number | null {
    const denom = this.totalPatuh + this.totalTidak;
    return denom > 0 ? Math.round((this.totalPatuh / denom) * 10000) / 100 : null;
  }

  get overallLabel(): string {
    const r = this.overallRate;
    if (r === null) return "Belum dinilai";
    if (r >= 85) return "BAIK";
    if (r >= 70) return "CUKUP";
    return "KURANG";
  }

  get overallColor(): string {
    const r = this.overallRate;
    if (r === null) return "grey";
    if (r >= 85) return "success";
    if (r >= 70) return "warning";
    return "error";
  }

  get canSubmit(): boolean {
    return this.filledCount > 0 && !this.dirty;
  }

  async saveAll() {
    this.saving = true;
    try {
      const responses = Object.values(this.responseMap).map(r => ({
        kriteria_no: r.kriteria_no,
        penilaian: r.penilaian,
        catatan: r.catatan
      }));
      await AuditKebersihanRuangService.bulkResponses(this.sessionId, responses);
      this.dirty = false;
      await this.loadSession();
      this.initResponses();
    } finally {
      this.saving = false;
    }
  }

  openSubmitDialog() {
    this.submitForm = { password: "" };
    this.submitDialog = true;
  }

  async confirmSubmit() {
    this.submitting = true;
    try {
      await AuditKebersihanRuangService.submitAuditor(this.sessionId, this.submitForm);
      this.submitDialog = false;
      this.$emit("submitted");
    } finally {
      this.submitting = false;
    }
  }
}
